import React from 'react';
const MessagesConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/apps/messages',
			component: React.lazy(() => import('./Messages'))
		}
	]
};
export default MessagesConfig;
